import axios from 'axios'
var instance = axios.create({
	baseURL: process.env.VUE_APP_API_ENDPOINT,
    responseType: 'blob',
})

instance.interceptors.request.use(
	(config) => {
		const authorization = localStorage.getItem('authorization_token')
		if (authorization) {
			config.headers.Authorization = "Bearer " + authorization;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

instance.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		// const { response } = error;

		// if (response) {
		// 	errorHandle(response.status, response.data.error);
		// }
		if (error.response) {
			return Promise.reject(JSON.stringify(error.response.data))
		}
		else {
			return Promise.reject(error);
		}
	}
);

export default function(method, url, data=null) {
	method = method.toLowerCase();

	switch (method) {
		case 'get':
			// console.log("get");
			return instance.get(url, {data: data})

		case 'post':
			// console.log("post");
			return instance.post(url, data)

		case 'put':
			// console.log("put");
			return instance.put(url, data)

		case 'patch':
			return instance.patch(url, data)

		case 'delete':
			// console.log("delete");
			return instance.delete(url, {data: data})

		default:
			console.error('unknown_request_method' + method)
			return false
	}
}
